/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Passes_BodyInputs */

const en_platform_passes_body = /** @type {(inputs: Platform_Passes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sell a pass of sessions and every visit takes one off. You see whose is running out and who hasn't paid yet.`)
};

const pl_platform_passes_body = /** @type {(inputs: Platform_Passes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprzedajesz pakiet wejść, a każda wizyta odejmuje jedno. Widzisz, komu się kończy i kto jeszcze nie zapłacił.`)
};

/**
* | output |
* | --- |
* | "Sell a pass of sessions and every visit takes one off. You see whose is running out and who hasn't paid yet." |
*
* @param {Platform_Passes_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_passes_body = /** @type {((inputs?: Platform_Passes_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Passes_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_passes_body(inputs)
	return en_platform_passes_body(inputs)
});